import { supabase } from '../lib/supabase'
import type { FiltroTrafego } from './trafegoPago'

type Base = { investimento: number; impressoes: number; cliques: number; conversoes: number; valorConversoes: number }
export type LinhaConjunto = Base & { id: string; nome: string; status: string | null; campanha: string; plataforma: string }
export type LinhaAnuncio = Base & {
  id: string
  nome: string
  status: string | null
  formato: string | null
  conjunto: string
  campanha: string
  plataforma: string
  /** Frequência de 7 dias da foto mais recente do período (não se soma entre dias). */
  frequencia: number | null
}
export type LinhaPosicionamento = Base & { nome: string; plataforma: string }
export type DetalheAnuncios = { conjuntos: LinhaConjunto[]; anuncios: LinhaAnuncio[]; posicionamentos: LinhaPosicionamento[] }

type Linha = Record<string, unknown>
const n = (v: unknown) => Number(v ?? 0)
const base = (r: Linha): Base => ({
  investimento: n(r.investimento),
  impressoes: n(r.impressoes),
  cliques: n(r.cliques),
  conversoes: n(r.conversoes),
  valorConversoes: n(r.valor_conversoes),
})

/** Conjuntos, anúncios e posicionamentos do recorte do painel (marca, plataforma, campanha). */
export async function carregarDetalheAnuncios(f: FiltroTrafego): Promise<DetalheAnuncios> {
  const args = {
    p_inicio: f.intervalo.inicio,
    p_fim: f.intervalo.fim,
    p_marca: f.marcaId || null,
    p_plataforma: f.plataforma || null,
    p_campanha: f.campanhaId || null,
  }
  const [c, a, p] = await Promise.all([
    supabase.rpc('trafego_pago_conjuntos', args),
    supabase.rpc('trafego_pago_anuncios', args),
    supabase.rpc('trafego_pago_posicionamentos', args),
  ])
  for (const r of [c, a, p]) if (r.error) throw new Error(r.error.message)
  return {
    conjuntos: ((c.data ?? []) as Linha[]).map((r) => ({
      ...base(r),
      id: String(r.conjunto_id),
      nome: String(r.conjunto),
      status: (r.status as string | null) ?? null,
      campanha: String(r.campanha),
      plataforma: String(r.plataforma),
    })),
    anuncios: ((a.data ?? []) as Linha[]).map((r) => ({
      ...base(r),
      id: String(r.anuncio_id),
      nome: String(r.anuncio),
      status: (r.status as string | null) ?? null,
      formato: (r.formato as string | null) ?? null,
      conjunto: String(r.conjunto),
      campanha: String(r.campanha),
      plataforma: String(r.plataforma),
      frequencia: r.frequencia == null ? null : n(r.frequencia),
    })),
    posicionamentos: ((p.data ?? []) as Linha[]).map((r) => ({ ...base(r), nome: String(r.posicionamento), plataforma: String(r.plataforma) })),
  }
}
